import {ApiEndPoint} from "../../network/api_end_point";
import {apiCaller, getToken} from "../../network/network_helper";
import {convertToEpocTimeInSecond, convertToEpocTimeInSecondOfEndDate} from "../../utils/date_time_convert_utils";
import StringUtils from "../../utils/string_utils";

const apiEndPoint = new ApiEndPoint();

export const pickupTaskListApiCall = async (taskType, query, hubId, pageSize, currentPage, selectedFilterItems, dateSelection, dateRange, specificDate) => {
    try {
        const token = getToken();
        const params = {};

        params.type = taskType;

        params.reporting_centre_id = hubId;

        if (pageSize) {
            params.page_size = pageSize;
        }

        if (currentPage) {
            params.page = currentPage;
        }

        if (query) {
            params.CP_AWB__in = query.join(",");
        }

        selectedFilterItems.forEach((value, key) => {
            if (key === "Vendor Location") {
                params.vendor_location = value.join(",");
            } else if (key === "City") {
                params.city = value.join(",");
            } else if (key === "Area") {
                params.area = value.join(",");
            } else if (key === "Concept") {
                params.concept = value.join(",");
            } else if (key === "Asset ID") {
                params.asset_filter = value.join(",");
            }
        });

        if (dateSelection === "Date Range" && dateRange.start !== null && dateRange.end !== null) {
            params.created_on_filter_type = dateSelection;
            params.order_booked_at_date__gte = convertToEpocTimeInSecond(dateRange.start);
            params.order_booked_at_date__lte = convertToEpocTimeInSecond(dateRange.end);
        } else if (dateSelection === "Specific Date" && specificDate !== null) {
            params.created_on_filter_type = dateSelection;
            params.order_booked_at_date__gte = convertToEpocTimeInSecond(specificDate);
            params.order_booked_at_date__lte = convertToEpocTimeInSecondOfEndDate(specificDate);
        } else if (dateSelection === "Up to Date" && specificDate !== null) {
            params.created_on_filter_type = dateSelection;
            params.order_booked_at_date__gte = "";
            params.order_booked_at_date__lte = convertToEpocTimeInSecondOfEndDate(specificDate);
        }

        params.source = apiEndPoint.source;

        const response = await apiCaller(
            apiEndPoint.hawkBaseUrl + apiEndPoint.orderLstApiUrl,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: params,
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const vendorDetailsApiCall = async () => {
    try {
        const token = getToken();

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.vendorNameApiUrl,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const locationListApiCall = async ({type = "VL", hubId, deliveryType}) => {
    try {
        const token = getToken();

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.warehouseUrl,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    "type": type,
                    "hub_id": hubId,
                    "delivery_type": deliveryType,
                },
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};


export const driverDetailsApiCall = async (hubId) => {
    try {
        const token = getToken();
        const channelId=localStorage.getItem('channelId');
        const response = await apiCaller(
            `${apiEndPoint.masterUrlWithChannelId(channelId)}drivers`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    "client_location_id": hubId,
                    status: StringUtils.active.toUpperCase(),
                    source: apiEndPoint.source,
                    page_size:5000,
                }
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};


export const countryListApiCall = async () => {
    try {
        const token = getToken();

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.getCountry,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};


export const cityListApiCall = async (countryCode) => {
    try {
        const token = getToken();

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.getCityWithOutState,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    'cc': countryCode,
                }
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const postalAreaListApiCall = async (countryCode, cityId) => {
    try {
        const token = getToken();

        const qParam = {
            'res_type': 'AREA_AND_CITY',
            'cc': countryCode,
        }
        if (cityId) {
            qParam.city_id = cityId;
        }
        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.getPostalCodeNew,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },

                params: qParam
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const createTaskApiCall = async (taskDetails) => {
    try {
        const token = getToken();
        const response = await apiCaller(
            apiEndPoint.hawkBaseUrl +
            apiEndPoint.createManualTaskApiUrl,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    source: apiEndPoint.source
                },
                data: taskDetails.toJson(),
            }
        );

        return response;
    } catch (e) {
        throw e;
    }
};

export const existingTaskListApiCall = async (taskType, hubId) => {
    try {
        const token = getToken();
        const qParam = {};
        if (taskType) {
            qParam.type = taskType;
        }
        if (hubId) {
            qParam.hub_id = hubId;
        }
        qParam.source= apiEndPoint.source;

        const response = await apiCaller(
            apiEndPoint.hawkBaseUrl + apiEndPoint.existingTaskListApiUrl,


            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: qParam
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};


export const individualLocationDetailsApi = async (id) => {
    try {
        const token = getToken();
        const uid = localStorage.getItem('uid');

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.warehouseUrl + `${id}`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    "uid": uid,
                },
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const addToExistingTaskApiCall = async (taskDetails, taskId) => {
    try {
        const token = getToken();
        const response = await apiCaller(
            apiEndPoint.hawkBaseUrl +
            apiEndPoint.addToExistingTaskApiUrl + `${taskId}/`,
            {
                method: "PUT",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params:{
                    source: apiEndPoint.source
                },
                data: taskDetails.toJson(),
            }
        );

        return response;
    } catch (e) {
        throw e;
    }
};

export const fmOrderCountApiCall = async () => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.fmOrderCountApi, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                reporting_centre_id: localStorage.getItem('clientLocationId'),
                channel_id: localStorage.getItem('channelId'),
                source: apiEndPoint.source
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
}
export const vendorListForFilterApiCall = async (taskType) => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.vendorListForFilterApiUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                type: taskType,
                reporting_centre_id: localStorage.getItem('clientLocationId'),
                channel_id: localStorage.getItem('channelId'),
                source: apiEndPoint.source
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
};
export const binListForFilterApiCall = async () => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.masterUrl + apiEndPoint.channel + String(localStorage.getItem('channelId')) + apiEndPoint.assetsLookup, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                asset_type_category: "BIN"
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
};
export const cityListForFilterApiCall = async (taskType) => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.cityListForFilterApiUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                type: taskType,
                reporting_centre_id: localStorage.getItem('clientLocationId'),
                channel_id: localStorage.getItem('channelId'),
                source: apiEndPoint.source
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
};
export const areaListForFilterApiCall = async (taskType) => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.areaListForFilterApiUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                type: taskType,
                reporting_centre_id: localStorage.getItem('clientLocationId'),
                channel_id: localStorage.getItem('channelId'),
                source: apiEndPoint.source
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
};
export const conceptListForFilterApiCall = async (taskType) => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.conceptListForFilterApiUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                type: taskType,
                reporting_centre_id: localStorage.getItem('clientLocationId'),
                channel_id: localStorage.getItem('channelId'),
                source: apiEndPoint.source
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
};